module.exports = __webpack_public_path__ + "static/logo_tagheuer-351abe658324a935f4d0e7e7d33bce23.svg";